import { fg } from '@atlaskit/platform-feature-flags';
import { useRovoContext } from '../rovo-context/rovo-context';
import { useUserContext } from '../user-context';

export const useShowAtlassianHomeSearchLink = (primaryProduct?: string) => {
	const { isRovoEnabled } = useRovoContext();
	const { orgId } = useUserContext();
	return !!(isRovoEnabled && orgId && primaryProduct === 'jira' && fg('jira_rovo_in_quick_search'));
};
